import chef1 from "../../../assets/images/chef-rajesh.jpg";
import chef2 from "../../../assets/images/chef-priya.jpg";
import chef3 from "../../../assets/images/chef-arjun.jpg";

const chefData = {
       hTxt : "Meet Our Culinary Masters",
       para : "Experienced chefs bringing authentic Indian flavors to your table",

      content: [
            {
            img: chef1,
            name: "Chef Rajesh Kumar",
            specialist: "Head Chef",
            experience: "20+ years in Indian cuisine"
            },
            {
            img: chef2,
            name: "Chef Priya Sharma",
            specialist: "Tandoor Specialist",
            experience: "Expert in North Indian grills"
            },
            {
            img: chef3,
            name: "Chef Arjun Singh",
            specialist: "Biryani Master",
            experience: "Hyderabadi biryani specialist"
            },
       ],
};

export default chefData;
